<template>
<div class="statistic-bar">
	<ul class="statistic-list">
		<li v-for="(item, index) in statisticList" :key="index">
			<span class="count">
				{{ item.count }}
				<sup class="sub-count">
					{{ item.subCount }}
				</sup>
			</span>
			<span class="name">
				{{ item.name }}
			</span>
			<span class="sub-name">
				{{ item.subname }}
			</span>
		</li>
	</ul>
	<div class="page-list">
		<h5>Alternative landing pages</h5>
		<ul>
			<li v-for="(item, index) in pages" :key="index">
				<router-link :to="item.path">{{ item.name }}</router-link>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
export default {
	data: () => ({
		statisticList: [
			{count: '87', subCount: '', name: 'Investment', subname: 'opportunites'},
			{count: '39b+', subCount: 'usd', name: 'In total', subname: 'value'},
			{count: '6.1b', subCount: 'usd', name: 'Fdi inflows', subname: 'In 2018'},
			{count: '68', subCount: 'of 190', name: '2019 world bank', subname: 'Doing business report'}
		],
		pages: [
			{ name: 'Logistics', path: '/logistics' },
			{ name: 'Tourism', path: '/tourism' },
			{ name: 'Explore Mines & Hydrocarbons', path: '/mines' },
			{ name: 'Explore Special Economic Zones', path: '/zones' }
		]
	})
}
</script>

<style lang="scss">
.statistic-bar {
	position: fixed;
	bottom: 0;
	width: 100%;
	background-color: rgba(20, 26, 33,0.8);
	opacity: 0;
	transition: opacity 1s linear;

	.statistic-list {
		list-style: none;
		padding: 0;
		margin: 0;
		float: left;
		padding: 24px 5px;

		li {
			text-align: left;
			color: #fff;
			display: grid;
			padding: 0px 10px;
			user-select: none;
			float: left;
			border-right: 1px solid #cacaca;
			height: 106px;
			
			&:last-child {
				border: none;
			}

			.count {
				font-size: 64px;
				white-space: nowrap;
				line-height: 65px;
			}
			.sub-count {
				font-weight: 500;
				text-transform: uppercase;
				font-size: 13px;
				position: relative;
				right: 13px;
				bottom: 10px;
			}
			.name {
				text-transform: uppercase;
				color: #4ba98b;
				font-size: 22px;
			}
			.sub-name {
				text-transform: uppercase;
				font-size: 14px;
				font-weight: 400;
				position: relative;
				bottom: 2px;
			}
		}
	}
	.page-list {
		float: right;
		background: rgba(13, 16, 19, 0.52);
		height: 114px;
		padding: 20px 70px;
		margin-right: 28px;
		width: 206px;

		h5 {
			margin: 0;
			color: #fff;
			text-align: left;
			text-transform: uppercase;
			font-size: 12px;
			font-weight: 500;
		}
		ul {
			list-style: none;
			text-align: left;
			padding: 0;
			margin: 10px 0 0 0;
			
			li {
				padding: 2px;

				a {
					color: #3794bf;
					text-decoration: none;
					font-size: 11px;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
}
</style>
